// reportBug.ts — send a user-written bug report to support@renurture.org. The app
// can't hold the Resend key, so it POSTs to the Worker endpoint (BUG_REPORT_URL),
// which emails support tagged as a bug report. Best-effort; returns true on success.
import { Capacitor } from '@capacitor/core';
import { BUG_REPORT_URL } from '@/config/backend';

const APP_VERSION = (import.meta.env.VITE_APP_VERSION as string) || 'renurture-app';

/** POST a bug report. `email` is optional (so support can reply). Adds light device
 *  context (platform / version / user agent) so reports are easier to triage. */
export async function reportBug(message: string, email?: string): Promise<boolean> {
  const body = message.trim();
  if (body.length < 3) return false;
  const context = [
    `platform=${Capacitor.getPlatform()}`,
    `version=${APP_VERSION}`,
    `ua=${typeof navigator !== 'undefined' ? navigator.userAgent : 'n/a'}`,
  ].join('; ');
  try {
    const r = await fetch(BUG_REPORT_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ message: body, email: (email || '').trim(), context }),
    });
    const j = (await r.json().catch(() => ({}))) as { ok?: boolean };
    return r.ok && j?.ok === true;
  } catch {
    return false;
  }
}
